export const OnSuccessAction = (paramParameters: any) => {
    return {
      type: 'onSuccess',
      paramParameters: paramParameters,
    }
  }
  